import React, { useState } from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Check } from 'lucide-react';
import LogoOption1 from './LogoOption1';
import LogoOption2 from './LogoOption2';
import LogoOption3 from './LogoOption3';
import LogoOption4 from './LogoOption4';

const LogoShowcase = () => {
  const [selectedLogo, setSelectedLogo] = useState(null);

  const logos = [
    { 
      id: 1, 
      component: LogoOption1, 
      name: 'Hexagon Tech', 
      description: 'Modern geometric hexagon with tech dots - represents connectivity and innovation'
    },
    { 
      id: 2, 
      component: LogoOption2, 
      name: 'Modern Square', 
      description: 'Clean minimalist square with rounded corners - professional and bold'
    },
    { 
      id: 3, 
      component: LogoOption3, 
      name: 'Connected Circles', 
      description: 'Abstract overlapping shapes - symbolizes collaboration and integration'
    },
    { 
      id: 4, 
      component: LogoOption4, 
      name: 'Professional Shield', 
      description: 'Shield badge design - represents security, trust and reliability'
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-emerald-50/30 to-white py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Choose Your TYJ Group Logo
          </h1>
          <p className="text-lg text-gray-600">
            Select the logo that best represents your brand identity
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {logos.map((logo) => {
            const LogoComponent = logo.component;
            return (
              <Card
                key={logo.id}
                className={`p-8 cursor-pointer transition-all duration-300 hover:shadow-2xl ${
                  selectedLogo === logo.id
                    ? 'ring-4 ring-emerald-500 shadow-2xl scale-105'
                    : 'hover:scale-105'
                }`}
                onClick={() => setSelectedLogo(logo.id)}
              >
                <div className="relative">
                  {selectedLogo === logo.id && (
                    <div className="absolute -top-4 -right-4 w-10 h-10 bg-emerald-500 rounded-full flex items-center justify-center shadow-lg z-10">
                      <Check className="w-6 h-6 text-white" />
                    </div>
                  )}
                  
                  <div className="bg-gray-100 rounded-xl p-8 mb-6 flex items-center justify-center">
                    <LogoComponent className="w-32 h-32" />
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">
                    Option {logo.id}: {logo.name}
                  </h3>
                  <p className="text-sm text-gray-600 text-center">
                    {logo.description}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>

        {selectedLogo && (
          <div className="text-center">
            <div className="inline-block bg-emerald-100 border-2 border-emerald-500 rounded-lg px-8 py-4">
              <p className="text-emerald-800 font-semibold text-lg">
                ✓ Logo Option {selectedLogo} Selected - Tell me which option you prefer!
              </p>
            </div>
          </div>
        )}

        {/* Preview Section */}
        <div className="mt-16 bg-white rounded-2xl shadow-xl p-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Logo Previews in Context
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            {logos.map((logo) => {
              const LogoComponent = logo.component;
              return (
                <div key={`preview-${logo.id}`} className="space-y-4">
                  <h3 className="font-semibold text-gray-700">Option {logo.id} - On Header</h3>
                  <div className="bg-white border rounded-lg p-4 flex items-center space-x-3">
                    <LogoComponent className="w-12 h-12" />
                    <span className="text-2xl font-bold bg-gradient-to-r from-emerald-500 to-emerald-600 bg-clip-text text-transparent">
                      TYJ Group
                    </span>
                  </div>
                  
                  <h3 className="font-semibold text-gray-700">Option {logo.id} - On Footer</h3>
                  <div className="bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-lg p-4 flex items-center space-x-3">
                    <LogoComponent className="w-12 h-12 brightness-0 invert" />
                    <span className="text-2xl font-bold text-white">
                      TYJ Group
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoShowcase;
